import { render } from "./IconPackages.vue?vue&type=template&id=76eef810"
import script from "./IconPackages.vue?vue&type=script&lang=ts"
export * from "./IconPackages.vue?vue&type=script&lang=ts"
script.render = render

export default script